import http from '@/services/http'

export default {
  getTourById (id) {
    return http.post(`/tour/id/${id}`, {
      referer: document.referrer
    })
  }
}
